export default{
    locations: [],
    location: null,
    pagesCount: 0,
    totalCountData: 0,
    currencies: []
}